/**
 * 时间 yyyy-MM-dd hh:mm:ss
 * @param {*} time 2023-10-09T04:36:11.000+00:00
 */
function dateFunction(time) {
  var zoneDate = new Date(time).toJSON();
  var date = new Date(+new Date(zoneDate) + 8 * 3600 * 1000)
    .toISOString()
    .replace(/T/g, " ")
    .replace(/\.[\d]{3}Z/, "");
  return date;
}

// 获取时间
function getCurrentToPreviousDateTimeRange(interval) {
  // 获取当前时间
  let currentDateTime = new Date();
  // 根据传入的间隔计算之前的时间
  let previousDateTime;
  switch (interval) {
    case "week":
      previousDateTime = new Date(currentDateTime - 7 * 24 * 60 * 60 * 1000);
      break;
    case "month":
      previousDateTime = new Date(
        currentDateTime.getFullYear(),
        currentDateTime.getMonth() - 1,
        currentDateTime.getDate()
      );
      break;
    case "halfYear":
      previousDateTime = new Date(
        currentDateTime.getFullYear(),
        currentDateTime.getMonth() - 6,
        currentDateTime.getDate()
      );
      break;
    case "year":
      previousDateTime = new Date(
        currentDateTime.getFullYear() - 1,
        currentDateTime.getMonth(),
        currentDateTime.getDate()
      );
      break;
    default:
      throw new Error("Invalid interval");
  }

  // 格式化日期时间为YYYY-MM-DD HH:mm:ss格式
  function formatDateTime(dateTime) {
    let year = dateTime.getFullYear();
    let month = (1 + dateTime.getMonth()).toString().padStart(2, "0");
    let day = dateTime.getDate().toString().padStart(2, "0");
    let hours = dateTime.getHours().toString().padStart(2, "0");
    let minutes = dateTime.getMinutes().toString().padStart(2, "0");
    let seconds = dateTime.getSeconds().toString().padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  // 返回时间区间
  return {
    start: formatDateTime(currentDateTime),
    end: formatDateTime(previousDateTime),
  };
}
//获取字典中对应的值
function getDictNameForValue(
  list,
  value,
  attrVal = "value",
  attrName = "label"
) {
  const data = list.filter((obj) => {
    return obj[attrVal] === value || obj[attrVal] + "" === value + "";
  });
  if (data.length !== 0) {
    return data[0][attrName];
  }
  return "";
}
//格式化时间
function formatDateTime(date, format) {
  const o = {
    "M+": date.getMonth() + 1, // 月份
    "d+": date.getDate(), // 日
    "h+": date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 小时
    "H+": date.getHours(), // 小时
    "m+": date.getMinutes(), // 分
    "s+": date.getSeconds(), // 秒
    "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
    a: date.getHours() < 12 ? "上午" : "下午", // 上午/下午
    A: date.getHours() < 12 ? "AM" : "PM", // AM/PM
  };
  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (let k in o) {
    if (new RegExp("(" + k + ")").test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return format;
}

// 获取区
function getRegion(regions, code) {
  if (!regions.length) return "";

  try {
    const children = regions[0].children;
    const list = children.find((item) => item.areaCode == code);
    return list.areaName;
  } catch (error) {}
}

// 一个月日期
function getOneMonth() {
  const currentDate = new Date();

  // 获取当前日期的前一个月
  const previousMonthDate = new Date(currentDate);
  previousMonthDate.setMonth(previousMonthDate.getMonth() - 1);

  // 格式化日期为 YYYY-MM-DD HH:mm:ss
  const formatDateTime = (date) => {
    const pad = (num) => String(num).padStart(2, "0");
    return (
      `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )} ` +
      `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
        date.getSeconds()
      )}`
    );
  };

  // 格式化当前日期（不调整时间）
  const formattedCurrentDate = formatDateTime(currentDate);

  // 返回前一个月和当前日期的完整格式
  return [formatDateTime(previousMonthDate), formattedCurrentDate];
}

function getTimeRange(type = "month", num = 1) {
  const currentDate = new Date();

  // 计算起始日期（前N个月/前N天）
  const startDate = new Date(currentDate);
  if (type === "month") {
    startDate.setMonth(startDate.getMonth() - num); // 前N个月
  } else if (type === "day") {
    startDate.setDate(startDate.getDate() - num); // 前N天
  }

  // 格式化日期为 YYYY-MM-DD HH:mm:ss（补零处理）
  const formatDateTime = (date) => {
    const pad = (num) => String(num).padStart(2, "0");
    return (
      `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
        date.getDate()
      )} ` +
      `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
        date.getSeconds()
      )}`
    );
  };

  // 起始时间（前N个月/前N天）+ 结束时间（当前时间）
  return [formatDateTime(startDate), formatDateTime(currentDate)];
}

function getDate(type = "month", num = 1) {
  const currentDate = new Date();
  const startDate = new Date(currentDate);

  if (type === "month") {
    startDate.setMonth(startDate.getMonth() - num);
  } else if (type === "day") {
    startDate.setDate(startDate.getDate() - num);
  }

  // 只格式化：YYYY-MM-DD
  const formatDate = (date) => {
    const pad = (num) => String(num).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  };

  return [formatDate(startDate), formatDate(currentDate)];
}

function translateTime(timestamp) {
  // 转换为毫秒（JavaScript 时间戳以毫秒为单位）
  const date = new Date(timestamp * 1000);

  // 格式化为 yyyy-mm-dd hh:mm:ss
  return (
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date.getDate()).padStart(2, "0")} ` +
    `${String(date.getHours()).padStart(2, "0")}:${String(
      date.getMinutes()
    ).padStart(2, "0")}:${String(date.getSeconds()).padStart(2, "0")}`
  );
}
/**
 * 计算文件大小
 * @param {*} bytes 字节
 * @returns 文件大小
 */
const formatSize = (bytes) => {
  if (bytes < 1024) {
    return `${bytes} bytes`;
  } else if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(2)} KB`;
  } else if (bytes < 1024 * 1024 * 1024) {
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
  } else {
    return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
  }
};

const isMobile = () => {
  const viewPortWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  const isMobileByWidth = viewPortWidth <= 768;
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobileByUA =
    /iphone|android|ipad|ipod|mobile|wechat|micromessenger|qq/i.test(userAgent);
  return isMobileByWidth || isMobileByUA;
};

function generateNameArray(seriesLength) {
[...Array(seriesLength).fill("水位标高"), ...Array(seriesLength).fill("水位埋深")];
}

export default {
  dateFunction,
  getCurrentToPreviousDateTimeRange,
  getDictNameForValue,
  formatDateTime,
  getRegion,
  getOneMonth,
  translateTime,
  formatSize,
  isMobile,
  getTimeRange,
  getDate,
  generateNameArray,
};



// WEBPACK FOOTER //
// ./src/common/js/util.js